// extracted by mini-css-extract-plugin
export default {"listItem":"faqs_listItem__7eafL","headingStyle":"faqs_headingStyle__RubUZ"};